import React, { useEffect, useRef, useState } from "react";
import { useResponsive } from "../../hook/useResponsive";
import LeftIcon from "../../images/LeftIcon";
import {
  webLoadingFalse,
  webLoadingTrue,
  webNavigate,
} from "../../services/navigate.service";
import {
  validateDecimalNumer,
  validateEmail,
  validateNoSpecialChars,
  validateNoSpecialCharsOrSpaces,
  validateOnlyNumbers,
  validateOnlyNumbersNotThree,
  validatePhoneNumber,
} from "../../validation/ValidationInput";
import ArrowClientsIcon from "../../images/ArrowClientsIcon";
import TableReport from "../../components/TableReport";
import ClientStatement from "./ClientStatement";
import { loadTerm } from "../../services/term.service";
import { getCompanies } from "../../services/company.service";
import { getCountries } from "../../services/country.service";
import {
  createClient,
  getActiveInvoice,
  getArchiveInvoice,
  getDetailClients,
  upadteDetailClients,
} from "../../services/client.service";
import PopupLocation from "../../components/PopupLocation";
import { showToast } from "../../services/toast.service";
import { showApiError } from "../../services/apiError";
import { coreFormLimits, limitProps, useFieldLimits, validateAgainstLimits } from "../../services/fieldLimits";
import FieldCounter from "../../components/FieldCounter";
import CheckIcon from "../../images/CheckIcon";
import BackIcon from "../../images/BackIcon";
import { DropdownSearch } from "../../components/DropdownSearch";
import { useFormKeyboard } from "../../hook/useFormKeyboard";

interface InforTable {
  title: string;
  path: string;
  desc: string;
  titleCreate: string;
}
interface Sales {
  id?: string;
  Invoice?: string;
  Client?: string;
  Date?: string;
  "Payment Term"?: string;
  Reference?: string;
  Balance?: string;
  Total?: string;
  Status?: string | null;
}
interface Purchases {
  id?: string;
  Invoice?: string;
  Client?: string;
  Date?: string;
  "Payment Term"?: string;
  Reference?: string;
  Balance?: string;
  Total?: string;
  Status?: string | null;
}
interface Country {
  id: string;
  code: string;
  name: string;
}
interface Company {
  name: string;
  value: number;
  id: number;
}
// The step showing each field, so a save error can jump to it.
const CLIENT_FIELD_STEPS: Record<string, number> = {
  clientNumber: 1, companyName: 1, companyType: 1, companyNumber: 1, taxCode: 1, referenceNo: 1, discountPercent: 1, debtLimit: 1,
  emailAddress: 2, phoneNumber: 2, addressLine1: 2, addressLine2: 2, countryId: 2, state: 2, city: 2, postalCode: 2,
};
const STEP_ONE_FIELDS = Object.keys(CLIENT_FIELD_STEPS).filter((field) => CLIENT_FIELD_STEPS[field] === 1);
const REQUIRED_MESSAGES: Record<string, string> = {
  city: "City is required",
  companyName: "Company Name is required",
  countryId: "Country is required",
  companyNumber: "Company Number is required",
  companyType: "Company Type is required",
};

const CreateClients = () => {
  const { isMobile, isTouchLayout, getWidth } = useResponsive();
  const [formValues, setFormValues] = useState<any>({
    city: "",
    companyName: "",
    countryId: "",
    companyNumber: "",
  });
  const [isToggled, setIsToggled] = useState(false);
  const handleToggle = () => {
    setIsToggled(!isToggled);
  };
  const [errors, setErrors] = useState<any>({});
  const [language, setLanguage] = useState<any>(null);
  const [invoicesActive, setInvoicesActive] = useState<any>([]);
  const [invoicesArchive, setInvoicesArchive] = useState<any>([]);
  const [tab, setTab] = useState<string>("profile");
  const path = window.location.pathname;
  const id: string = path.split("/").pop() || "";
  const [step, setStep] = useState<number>(1);
  const limits = useFieldLimits(coreFormLimits("client"));
  // From the host's desktop breakpoint (1024), where isMobile (<= 1024) would still skip it.
  const kb = useFormKeyboard({ step, autoFocus: id === "new" && !isTouchLayout });
  const scrollRef = useRef<HTMLDivElement>(null);
  // Each step opens at its top, so an error shown when Save jumps back to step 1 is in view.
  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = 0;
  }, [step]);
  const companyId: string = localStorage.getItem("companyId") || "";
  const [filterActive, setFilterActive] = useState<any>({
    page: 1,
    limit: 50,
    companyId,
    id,
  });
  const [filterArchive, setFilterArchive] = useState<any>({
    page: 1,
    limit: 50,
    companyId,
    id,
  });
  const [payment, setPayemnt] = useState<Country[]>([
    {
      id: "1",
      code: "123e4567-e89b-12d3-a456-426614174000",
      name: "ABC Company",
    },
    {
      id: "2",
      code: "123e4567-e89b-12d3-a456-426614174001",
      name: "Dunder Mifflin",
    },
    {
      id: "3",
      code: "123e4567-e89b-12d3-a456-426614174002",
      name: "Monsters Inc",
    },
    {
      id: "4",
      code: "123e4567-e89b-12d3-a456-426614174003",
      name: "Wonka Industries",
    },
  ]);
  const [country, setCountry] = useState<Country[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [companies, setCompanies] = useState<Company[]>([
    { name: "SalesClient", value: 1, id: 1 },
    { name: "Supplier", value: 2, id: 2 },
    { name: "All", value: 3, id: 3 },
  ]);
  const [searchCompany, setSearchCompany] = useState("");
  const [searchCountry, setSearchCountry] = useState("");
  const [priceType, setPriceType] = useState<string>("");
  const [isCompanyDropdownOpen, setIsCompanyDropdownOpen] = useState(false);
  const [isPriceTypeDropdownOpen, setIsPriceTypeDropdownOpen] = useState(false);
  const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false);
  const dropdownCompanyRef = useRef<HTMLDivElement>(null);
  const dropdownCountryRef = useRef<HTMLDivElement>(null);
  const dropdownPriceTypeRef = useRef<HTMLDivElement>(null);
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);
  const calculatedWidth = windowWidth / 1290;
  const preLanguage = localStorage.getItem("language");
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownCompanyRef.current &&
        !dropdownCompanyRef.current.contains(event.target as Node)
      ) {
        setIsCompanyDropdownOpen(false);
      }
      if (
        dropdownCountryRef.current &&
        !dropdownCountryRef.current.contains(event.target as Node)
      ) {
        setIsCountryDropdownOpen(false);
      }
      if (
        dropdownPriceTypeRef.current &&
        !dropdownPriceTypeRef.current.contains(event.target as Node)
      ) {
        setIsPriceTypeDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (id !== "new") {
      fetchData(id);
      getListActiveInvoice();
      getListArchiveInvoice();
    }
    const handleNewToken = () => {
      if (id !== "new") {
        fetchData(id);
        getListActiveInvoice();
        getListArchiveInvoice();
      }
    };
    document.addEventListener("newToken", handleNewToken);
    return () => {
      document.removeEventListener("newToken", handleNewToken);
    };
  }, [path]);
  useEffect(() => {
    if (window.languageContext) {
      setLanguage(window.languageContext.language);
    }
  }, [window, window.languageContext]);
  const getListActiveInvoice = async () => {
    setLoading(true);
    try {
      const response: any = await getActiveInvoice(filterActive);
      const value: any = response.data.data;
      let tempArraySales: Sales[] = [];
      value?.dataSales?.sales?.forEach((each: any, index: any) => {
        const saleDetailsAmount = each?.saleDetails
          ? each.saleDetails.reduce(
            (acc: any, val: any) => acc + Number(val.amount),
            0,
          )
          : 0;
        tempArraySales.push({
          id: each.id,
          Invoice: each.invoiceNumber,
          Date: each.dueDate,
          "Payment Term": each.term.termName,
          Reference: each.reference,
          Balance:
            (
              (each.amountPaid ? Number(each?.amountPaid) : 0) -
              saleDetailsAmount
            ).toFixed(2) + " €",
          Total: saleDetailsAmount.toFixed(2) + " €",
          Status: each.status.statusName,
        });
      });
      setInvoicesActive({
        count: value?.dataSales?.total,
        data: tempArraySales,
      });
    } catch (error) {
      console.error("Error loading terms:", error);
    } finally {
      setLoading(false);
    }
  };
  const getListArchiveInvoice = async () => {
    setLoading(true);
    try {
      const response: any = await getArchiveInvoice(filterActive);
      const value: any = response.data.data;
      let tempArraySales: Sales[] = [];
      let tempArrayPurchases: Purchases[] = [];
      value?.dataSales?.sales?.forEach((each: any, index: any) => {
        const saleDetailsAmount = each?.saleDetails
          ? each.saleDetails.reduce(
            (acc: any, val: any) => acc + Number(val.amount),
            0,
          )
          : 0;
        tempArraySales.push({
          id: each.id,
          Invoice: each.invoiceNumber,
          Date: each.dueDate,
          "Payment Term": each.term.termName,
          Reference: each.reference,
          Balance:
            (
              (each.amountPaid ? Number(each?.amountPaid) : 0) -
              saleDetailsAmount
            ).toFixed(2) + " €",
          Total: saleDetailsAmount.toFixed(2) + " €",
          Status: each.status.statusName,
        });
      });
      setInvoicesArchive({
        count: value?.dataSales?.total,
        data: tempArraySales,
      });
    } catch (error) {
      console.error("Error loading terms:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async (id: string) => {
    webLoadingTrue();
    try {
      const response: any = await getDetailClients(id);
      const data: any = {
        ...response.data,
        countryId: response.data.country.id,
      };
      setFormValues(data);
      setIsToggled(data.requiresApproval);
      setSearchCountry(response.data.country.countryName);
      const companyPayload: any = companies?.filter(
        (v: any) => v.value === response.data.companyType,
      );
      setSearchCompany(companyPayload[0]?.name || "");
      // setPriceType(paymentPaylaoad[0]?.name || "")
    } catch (error) {
      console.error("Error loading terms:", error);
    } finally {
      webLoadingFalse();
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    getListContry();
    const handleNewToken = () => {
      getListContry();
    };
    document.addEventListener("newToken", handleNewToken);
    return () => {
      document.removeEventListener("newToken", handleNewToken);
    };
  }, []);

  const getListContry = async () => {
    try {
      const data = await getCountries();
      setCountry(data);
    } catch (error) {
      console.error("Error loading terms:", error);
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>,
  ) => {
    const { name, value, type } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };
  const handlCountrySelect = (country: any) => {
    setFormValues((prev: any) => ({ ...prev, countryId: country.id }));
    setSearchCountry(country.name);
    setIsCountryDropdownOpen(false);
  };

  const handleCompanySelect = (value: any) => {
    setFormValues((prev: any) => ({
      ...prev,
      companyType: value.value,
    }));
    setSearchCompany(value.name);
    setIsCompanyDropdownOpen(false);
  };
  const handlePaymentSelect = (priceType: string, priceName: string) => {
    setFormValues((prev: any) => ({ ...prev, priceBandId: priceType }));
    setPriceType(priceName);
    setIsPriceTypeDropdownOpen(false);
  };
  const handleClosePopup = () => {
    setShowPopup(false);
  };
  const handleOpenPopup = () => {
    setShowPopup(true);
  };
  // The API limits plus the presence checks this form has always made, for the given fields.
  const checkFields = (fields: string[]) => {
    const found: Record<string, string> = validateAgainstLimits(formValues, limits, language, fields);
    for (const field of fields) {
      const required = REQUIRED_MESSAGES[field];
      if (required && !formValues[field]) found[field] = language?.[required] ?? required;
    }
    return found;
  };
  const handleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    const newErrors: any = checkFields(Object.keys(CLIENT_FIELD_STEPS));
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      if (Object.keys(newErrors).some((field) => CLIENT_FIELD_STEPS[field] === 1)) setStep(1);
      return;
    }
    webLoadingTrue();
    const payload: any = {
      ...formValues,
      companyId: localStorage.getItem("companyId") || "",
      requiresApproval: isToggled,
      priceBandId: "123e4567-e89b-12d3-a456-426614174001",
      debtLimit: Number(formValues.debtLimit),
      discountPercent: Number(formValues.discountPercent),
    };
    if (id === "new") {
      try {
        const response: any = await createClient(payload);
        if (response?.data?.id) {
          webNavigate("/" + preLanguage + "/clients");
          webLoadingFalse();
          showToast({
            message: "Client added successfully !",
            type: "success",
            duration: 20000,
          });
        }
      } catch (error: any) {
        webLoadingFalse();

        showApiError(error, { language, setFieldErrors: setErrors, fieldSteps: CLIENT_FIELD_STEPS, onStep: setStep });
      }
    } else {
      try {
        const response: any = await upadteDetailClients(id, payload);
        if (response?.data?.id) {
          webNavigate("/" + preLanguage + "/clients");
          webLoadingFalse();
          showToast({
            message: "Client added successfully !",
            type: "success",
            duration: 20000,
          });
        }
      } catch (error: any) {
        webLoadingFalse();

        showApiError(error, { language, setFieldErrors: setErrors, fieldSteps: CLIENT_FIELD_STEPS, onStep: setStep });
      }
    }
  };

  const handleReceivePageNumberActive = (pageNumber: number) => {
    setFilterActive({ ...filterActive, page: pageNumber });
  };
  const handleReceivePageNumberArchice = (pageNumber: number) => {
    setFilterArchive({ ...filterArchive, page: pageNumber });
  };
  return (
    <div className="h-full" style={{ height: "100%", overflowY: "auto" }}>
      <div className="flex items-center ">
        <button
          type="button"
          key={step === 1 ? "exit" : "back"}
          aria-label={language?.["Back"] ?? "Back"}
          className="w-6 h-6 flex items-center justify-center cursor-pointer"
          {...kb.stepProps(() => {
            step === 1
              ? webNavigate("/" + preLanguage + "/clients")
              : setStep(1);
          })}
        >
          <BackIcon />
        </button>
        <p
          style={{
            fontSize: "14px",
            fontWeight: "500",
            lineHeight: "28px",
            color: "#222525",
          }}
          className="font-inter"
        >
          {language && language?.["Back"] ? language?.["Back"] : "Back"}
        </p>
      </div>
      {id === "new" ? (
        <p
          style={{
            margin: "20px 0px",
            fontSize: "20px",
            fontWeight: "500",
            lineHeight: "28px",
            color: "#222525",
          }}
          className="font-inter"
        >
          {language && language?.["Add Client"]
            ? language?.["Add Client"]
            : "Add Client"}
        </p>
      ) : (
        <p
          style={{
            margin: "20px 0px",
            fontSize: "20px",
            fontWeight: "500",
            lineHeight: "28px",
            color: "#222525",
          }}
          className="font-inter"
        >
          {language && language?.["Edit Client"]
            ? language?.["Edit Client"]
            : "Edit Client"}
        </p>
      )}
      {id !== "new" && (
        <div
          className="font-inter"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "24px",
          }}
        >
          {[
            { key: "profile", label: language && language?.["Profile"] ? language?.["Profile"] : "Profile" },
            { key: "statement", label: language && language?.["Statement"] ? language?.["Statement"] : "Statement" },
          ].map((it) => {
            const active = (tab === "statement" ? "statement" : "profile") === it.key;
            return (
              <button
                type="button"
                key={it.key}
                aria-pressed={active}
                onClick={() => setTab(it.key)}
                className="cursor-pointer font-inter transition-colors"
                style={{
                  padding: "8px 18px",
                  borderRadius: "20px",
                  fontSize: "14px",
                  fontWeight: 500,
                  backgroundColor: active ? "#0F7679" : "transparent",
                  color: active ? "#FFFFFF" : "#4A5353",
                  border: `1px solid ${active ? "#0F7679" : "#EBF0F0"}`,
                }}
              >
                {it.label}
              </button>
            );
          })}
        </div>
      )}
      {/* Scoped to the profile so the statement tab's fields never press Save. */}
      <div {...kb.scopeProps}>
      <div style={{ display: tab === "statement" ? "none" : undefined }}>
      <div
        className={`${isMobile ? "space-y-3" : ""} lg:flex items-center`}
        style={{ gap: "20px", marginBottom: "24px" }}
      >
        <div
          className=""
          style={{
            width: isMobile ? "100%" : "calc(50% - 10px)",
            display: isMobile ? "flex" : "",
            gap: isMobile ? "8px" : "",
          }}
        >
          <div
            className="w-full"
            style={{
              minHeight: isMobile ? "100%" : "4px",
              width: isMobile ? "2px" : "100%",
              backgroundColor: step === 1 || step === 2 ? "#0F7679" : "#DBE4E4",
              borderRadius: "20px",
            }}
          ></div>
          <div className="" style={{ marginTop: isMobile ? "" : "12px" }}>
            <div className="flex items-center" style={{ gap: "8px" }}>
              {step === 2 && (
                <div
                  className="flex items-center justify-center"
                  style={{ width: "20px", height: "20px" }}
                >
                  <CheckIcon />
                </div>
              )}
              <p
                className="font-medium text-[14px] font-inter leading-[20px]"
                style={{ color: "#0F7679" }}
              >
                {language && language?.["Step 1"]
                  ? language?.["Step 1"]
                  : "Step 1"}
              </p>
            </div>
            <p
              className="font-medium text-[14px] font-inter leading-[20px]"
              style={{ color: "#05292A" }}
            >
              {language && language?.["Company information"]
                ? language?.["Company information"]
                : "Company information"}
            </p>
          </div>
        </div>
        <div
          className=""
          style={{
            width: isMobile ? "100%" : "calc(50% - 10px)",
            display: isMobile ? "flex" : "",
            gap: isMobile ? "8px" : "",
          }}
        >
          <div
            className=""
            style={{
              minHeight: isMobile ? "100%" : "4px",
              width: isMobile ? "2px" : "100%",
              backgroundColor: step === 2 ? "#0F7679" : "#DBE4E4",
              borderRadius: "20px",
            }}
          ></div>
          <div className="" style={{ marginTop: isMobile ? "" : "12px" }}>
            <div className="flex items-center">
              <p
                className="font-medium text-[14px] font-inter leading-[20px]"
                style={{ color: "#0F7679" }}
              >
                {language && language?.["Step 2"]
                  ? language?.["Step 2"]
                  : "Step 2"}
              </p>
            </div>
            <p
              className="font-medium text-[14px] font-inter leading-[20px]"
              style={{ color: "#05292A" }}
            >
              {language && language?.["Contact & Location"]
                ? language?.["Contact & Location"]
                : "Contact & Location"}
            </p>
          </div>
        </div>
      </div>
      <div
        ref={scrollRef}
        className="scroll-container"
        style={{
          height: isMobile ? "calc(100% - 275px)" : "calc(100% - 231px)",
          overflowY: "scroll",
          paddingBottom: isMobile ? '16px' : '0px'
        }}
      >
        <form>
          {step === 1 ? (
            // Keyed per step so React builds fresh inputs; reused ones kept step 1's text on screen.
            <div
              key="client-step-1"
              className="flex items-start justify-between"
              style={{ flexWrap: "wrap", gap: "24px" }}
            >
              {id === "new" && (
                <div
                  className="space-y-2"
                  style={{ width: isMobile ? "100%" : "calc(33% - 12px)" }}
                >
                  <div className="flex items-center">
                    <p
                      className="text-[14px] font-inter leading-[20px]"
                      style={{ color: "#4A5353", fontWeight: "500" }}
                    >
                      {language && language?.["Client No"]
                        ? language?.["Client No"]
                        : "Client No"}
                    </p>
                  </div>
                  <div className="w-full">
                    <input
                      disabled
                      value={formValues?.clientNumber}
                      onKeyDown={validateNoSpecialChars}
                      name="clientNumber"
                      onChange={(e: any) => {
                        handleChange(e);
                      }}
                      style={{ backgroundColor: "#EBF0F0" }}
                      className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                    />
                  </div>
                </div>
              )}
              <div
                className="space-y-2"
                style={{
                  width:
                    id === "new"
                      ? isMobile
                        ? "100%"
                        : "calc(33% - 12px)"
                      : isMobile
                        ? "100%"
                        : "calc(50% - 12px)",
                }}
              >
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353", fontWeight: "500" }}
                  >
                    {language && language?.["Company Name"]
                      ? language?.["Company Name"]
                      : "Company Name"}
                  </p>
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#BA0E13" }}
                  >
                    {language && language?.["*"] ? language?.["*"] : "*"}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    type="text"
                    name="companyName"
                    {...limitProps(limits, "companyName")}
                    required
                    value={formValues?.companyName}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                  <FieldCounter value={formValues?.companyName} max={limits.companyName?.maxLength} />
                </div>
                {errors.companyName && (
                  <p className="error">{errors.companyName}</p>
                )}
              </div>
              <div
                className="space-y-2"
                style={{
                  width:
                    id === "new"
                      ? isMobile
                        ? "100%"
                        : "calc(33% - 12px)"
                      : isMobile
                        ? "100%"
                        : "calc(50% - 12px)",
                }}
              >
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353", fontWeight: "500" }}
                  >
                    {language && language?.["Type"]
                      ? language?.["Type"]
                      : "Type"}
                  </p>
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#BA0E13" }}
                  >
                    {language && language?.["*"] ? language?.["*"] : "*"}
                  </p>
                </div>
                <div className="w-full">
                  <DropdownSearch
                    refKey="type"
                    refs={{ type: dropdownCompanyRef }}
                    openStates={{ type: isCompanyDropdownOpen }}
                    open={(key) =>
                      key === "type" && setIsCompanyDropdownOpen(true)
                    }
                    close={(key) =>
                      key === "type" && setIsCompanyDropdownOpen(false)
                    }
                    data={companies}
                    labelExtractor={(item) => item.name}
                    value={searchCompany}
                    setValue={setSearchCompany}
                    onSelect={handleCompanySelect}
                    error={errors.companyType}
                    borderNone={false}
                  />
                </div>
              </div>
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(33% - 12px)" }}
              >
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353", fontWeight: "500" }}
                  >
                    {language && language?.["Company No"]
                      ? language?.["Company No"]
                      : "Company No"}
                  </p>
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#BA0E13" }}
                  >
                    {language && language?.["*"] ? language?.["*"] : "*"}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    type="text"
                    name="companyNumber"
                    {...limitProps(limits, "companyNumber")}
                    value={formValues?.companyNumber}
                    onKeyDown={validateOnlyNumbersNotThree}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                  <FieldCounter value={formValues?.companyNumber} max={limits.companyNumber?.maxLength} />
                </div>
                {errors.companyNumber && (
                  <p className="error">{errors.companyNumber}</p>
                )}
              </div>
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(33% - 12px)" }}
              >
                <div className="flex items-center justify-between">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353", fontWeight: "500" }}
                  >
                    {language && language?.["TAX No"]
                      ? language?.["TAX No"]
                      : "TAX No"}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    value={formValues?.taxCode}
                    onKeyDown={validateNoSpecialChars}
                    name="taxCode"
                    {...limitProps(limits, "taxCode")}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                  <FieldCounter value={formValues?.taxCode} max={limits.taxCode?.maxLength} />
                </div>
                {errors.taxCode && <p className="error">{errors.taxCode}</p>}
              </div>
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(33% - 12px)" }}
              >
                <div className="flex items-center justify-between">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353", fontWeight: "500" }}
                  >
                    {language && language?.["Reference No"]
                      ? language?.["Reference No"]
                      : "Reference No"}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    value={formValues?.referenceNo}
                    onKeyDown={validateNoSpecialChars}
                    name="referenceNo"
                    {...limitProps(limits, "referenceNo")}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                  <FieldCounter value={formValues?.referenceNo} max={limits.referenceNo?.maxLength} />
                </div>
                {errors.referenceNo && (
                  <p className="error">{errors.referenceNo}</p>
                )}
              </div>
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
              >
                <div className="flex items-center justify-between">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353", fontWeight: "500" }}
                  >
                    {language && language?.["Discount"]
                      ? language?.["Discount"]
                      : "Discount"}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    type="text"
                    onKeyDown={validateDecimalNumer}
                    name="discountPercent"
                    value={formValues?.discountPercent}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                </div>
                {errors.discountPercent && (
                  <p className="error">{errors.discountPercent}</p>
                )}
              </div>
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
              >
                <div className="flex items-center justify-between">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353", fontWeight: "500" }}
                  >
                    {language && language?.["Credit Limit"]
                      ? language?.["Credit Limit"]
                      : "Credit Limit"}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    type="text"
                    onKeyDown={validateOnlyNumbersNotThree}
                    name="debtLimit"
                    value={formValues?.debtLimit}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                </div>
                {errors.debtLimit && (
                  <p className="error">{errors.debtLimit}</p>
                )}
              </div>
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
              >
                <div className="flex items-center justify-between">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353", fontWeight: "500" }}
                  >
                    {language && language?.["Price Band"]
                      ? language?.["Price Band"]
                      : "Price Band"}
                  </p>
                </div>
                <div className="w-full">
                  <div className="relative" ref={dropdownPriceTypeRef}>
                    <input
                      type="text"
                      disabled
                      onKeyDown={validateNoSpecialChars}
                      // value={priceType}
                      defaultValue={"Standard"}
                      onChange={(e) => {
                        setPriceType(e.target.value);
                        setIsPriceTypeDropdownOpen(true);
                      }}
                      onClick={() => setIsPriceTypeDropdownOpen(true)}
                      className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                    />
                    {isPriceTypeDropdownOpen && (
                      <div className="absolute z-10 w-full mt-1 bg-white border border-[#EBEBED] rounded-lg max-h-60 overflow-auto p-1 shadow-extend">
                        {payment
                          .filter((payment) =>
                            payment?.name
                              .toLowerCase()
                              .includes(priceType?.toLowerCase()),
                          )
                          .map((payment) => (
                            <div
                              key={payment?.id}
                              style={{
                                padding: "8px 6px",
                                borderRadius: "4px",
                              }}
                              className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300"
                              onClick={() =>
                                handlePaymentSelect(
                                  payment?.code,
                                  payment?.name,
                                )
                              }
                            >
                              Standard
                            </div>
                          ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
              key="client-step-2"
              className="flex items-start justify-between"
              style={{ flexWrap: "wrap", gap: "20px" }}
            >
              <div
                style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
                className="space-y-2"
              >
                <div className="flex items-center justify-between">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353", fontWeight: "500" }}
                  >
                    {language && language?.["Email"]
                      ? language?.["Email"]
                      : "Email"}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    type="text"
                    name="emailAddress"
                    {...limitProps(limits, "emailAddress")}
                    // onKeyDown={validateEmail}
                    value={formValues?.emailAddress}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                  <FieldCounter value={formValues?.emailAddress} max={limits.emailAddress?.maxLength} />
                </div>
                {errors.emailAddress && (
                  <p className="error">{errors.emailAddress}</p>
                )}
              </div>
              <div
                style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
                className="space-y-2"
              >
                <div className="flex items-center justify-between">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353", fontWeight: "500" }}
                  >
                    {language && language?.["Phone Number"]
                      ? language?.["Phone Number"]
                      : "Phone Number"}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    type="text"
                    name="phoneNumber"
                    {...limitProps(limits, "phoneNumber")}
                    value={formValues?.phoneNumber}
                    onKeyDown={validatePhoneNumber}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                  <FieldCounter value={formValues?.phoneNumber} max={limits.phoneNumber?.maxLength} />
                </div>
                {errors.phoneNumber && (
                  <p className="error">{errors.phoneNumber}</p>
                )}
              </div>
              <div
                style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
                className="space-y-2"
              >
                <div className="flex items-center justify-between">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353", fontWeight: "500" }}
                  >
                    {language && language?.["Address Line 1"]
                      ? language?.["Address Line 1"]
                      : "Address Line 1"}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    type="text"
                    name="addressLine1"
                    {...limitProps(limits, "addressLine1")}
                    required
                    value={formValues?.addressLine1}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                  <FieldCounter value={formValues?.addressLine1} max={limits.addressLine1?.maxLength} />
                </div>
                {errors.addressLine1 && (
                  <p className="error">{errors.addressLine1}</p>
                )}
              </div>
              <div
                style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
                className="space-y-2"
              >
                <div className="flex items-center justify-between">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353", fontWeight: "500" }}
                  >
                    {language && language?.["Address Line 2"]
                      ? language?.["Address Line 2"]
                      : "Address Line 2"}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    type="text"
                    name="addressLine2"
                    {...limitProps(limits, "addressLine2")}
                    required
                    value={formValues?.addressLine2}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                  <FieldCounter value={formValues?.addressLine2} max={limits.addressLine2?.maxLength} />
                </div>
                {errors.addressLine2 && (
                  <p className="error">{errors.addressLine2}</p>
                )}
              </div>
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
              >
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353", fontWeight: "500" }}
                  >
                    {language && language?.["Country"]
                      ? language?.["Country"]
                      : "Country"}
                  </p>
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#BA0E13" }}
                  >
                    {language && language?.["*"] ? language?.["*"] : "*"}
                  </p>
                </div>
                <div className="w-full">
                  <DropdownSearch
                    refKey="type"
                    refs={{ type: dropdownCountryRef }}
                    openStates={{ type: isCountryDropdownOpen }}
                    open={(key) =>
                      key === "type" && setIsCountryDropdownOpen(true)
                    }
                    close={(key) =>
                      key === "type" && setIsCountryDropdownOpen(false)
                    }
                    data={country}
                    labelExtractor={(item) => item.name}
                    value={searchCountry}
                    setValue={setSearchCountry}
                    onSelect={handlCountrySelect}
                    error={errors.countryId}
                    borderNone={false}
                  />
                </div>
              </div>
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
              >
                <div className="space-y-2">
                  <div className="flex items-center justify-between">
                    <p
                      className="text-[14px] font-inter leading-[20px]"
                      style={{ color: "#4A5353", fontWeight: "500" }}
                    >
                      {language && language?.["State"]
                        ? language?.["State"]
                        : "State"}
                    </p>
                  </div>
                  <div className="w-full">
                    <input
                      type="text"
                      name="state"
                      {...limitProps(limits, "state")}
                      onKeyDown={validateNoSpecialChars}
                      value={formValues?.state}
                      onChange={(e: any) => {
                        handleChange(e);
                      }}
                      className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                    />
                    <FieldCounter value={formValues?.state} max={limits.state?.maxLength} />
                  </div>
                  {errors.state && <p className="error">{errors.state}</p>}
                </div>
              </div>
              <div
                className=""
                style={{ width: isMobile ? "100%" : "calc(33% - 12px)" }}
              >
                <div className="space-y-2">
                  <div className="flex items-center">
                    <p
                      className="text-[14px] font-inter leading-[20px]"
                      style={{ color: "#4A5353", fontWeight: "500" }}
                    >
                      {language && language?.["City"]
                        ? language?.["City"]
                        : "City"}
                    </p>
                    <p
                      className="text-[14px] font-inter leading-[20px]"
                      style={{ color: "#BA0E13" }}
                    >
                      {language && language?.["*"] ? language?.["*"] : "*"}
                    </p>
                  </div>
                  <div className="w-full">
                    <input
                      type="text"
                      name="city"
                      {...limitProps(limits, "city")}
                      onKeyDown={validateNoSpecialChars}
                      value={formValues?.city}
                      onChange={(e: any) => {
                        handleChange(e);
                      }}
                      className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                    />
                    <FieldCounter value={formValues?.city} max={limits.city?.maxLength} />
                  </div>
                  {errors.city && <p className="error">{errors.city}</p>}
                </div>
              </div>
              <div
                className=""
                style={{ width: isMobile ? "100%" : "calc(33% - 12px)" }}
              >
                <div className="space-y-2">
                  <div className="flex items-center justify-between">
                    <p
                      className="text-[14px] font-inter leading-[20px]"
                      style={{ color: "#4A5353", fontWeight: "500" }}
                    >
                      {language && language?.["Postal Code"]
                        ? language?.["Postal Code"]
                        : "Postal Code"}
                    </p>
                  </div>
                  <div className="w-full">
                    <input
                      type="text"
                      name="postalCode"
                      {...limitProps(limits, "postalCode")}
                      onKeyDown={validateNoSpecialChars}
                      value={formValues?.postalCode}
                      onChange={(e: any) => {
                        handleChange(e);
                      }}
                      className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                    />
                    <FieldCounter value={formValues?.postalCode} max={limits.postalCode?.maxLength} />
                  </div>
                  {errors.postalCode && (
                    <p className="error">{errors.postalCode}</p>
                  )}
                </div>
              </div>
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(33% - 12px)" }}
              >
                <p
                  className="text-[14px] leading-[20px] font-inter"
                  style={{ color: "#4A5353", fontWeight: "500" }}
                >
                  {language && language?.["Require order approval"]
                    ? language?.["Require order approval"]
                    : "Require order approval"}
                </p>
                <div className="h-10 flex items-center">
                  <div
                    className={`switch ${isToggled ? "on" : "off"}`}
                    onClick={handleToggle}
                    role="switch"
                    aria-checked={!!isToggled}
                    aria-label={language?.["Require order approval"] ?? "Require order approval"}
                    tabIndex={0}
                    onKeyDown={(e) => {
                      // Space only, as on a native checkbox; Enter is left to the form.
                      if (e.key !== " " || e.ctrlKey || e.metaKey || e.altKey) return;
                      e.preventDefault();
                      if (!e.repeat) handleToggle();
                    }}
                  >
                    <div
                      className={`shadow_toggle slider ${isToggled ? "move-right" : "move-left"}`}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </form>
      </div>
      <div
        className="w-full flex items-center justify-end shadow_button relative"
        style={{ gap: "12px", paddingTop: "24px", }}
      >
        <div className="absolute" style={{ left: "-24px", top: 0, height: "1px", backgroundColor: "#DBE4E4", width: isMobile ? 'calc(100vw + 32px)' : "calc(-256px + 48px + 100vw)" }}></div>
        {/* Keyed apart too: a focused Back must not become Cancel, where one more Enter leaves. */}
        <button
          type="button"
          key={step === 1 ? "cancel" : "back"}
          {...kb.stepProps(() => {
            step === 1 ? webNavigate("/" + preLanguage + "/clients") : setStep(1)
          })}
          style={{
            padding: "10px 20px",
            borderRadius: "30px",
            color: "#222525",
            fontSize: "14px",
            fontWeight: "500",
            border: "1px solid #C9D7D8",
          }}
          className="font-inter cursor-pointer"
        >
          {step === 1 ?
            language && language?.['Cancel'] ? language?.['Cancel'] : 'Cancel'
            :
            language && language?.['Back'] ? language?.['Back'] : 'Back'
          }
        </button>
        {/* Keyed apart so a focused Next is not reused as Save, where one more Enter would save. */}
        {step === 1 ? (
          <button
            type="button"
            key="next"
            {...kb.primaryProps(() => {
              const stepErrors = checkFields(STEP_ONE_FIELDS);
              setErrors(stepErrors);
              if (Object.keys(stepErrors).length === 0) setStep(2);
            })}
            style={{
              padding: "10px 20px",
              borderRadius: "30px",
              color: "#FFFFFF",
              fontSize: "14px",
              fontWeight: "500",
              backgroundColor: "#0F7679",
            }}
            className="font-inter cursor-pointer"
          >
            {language && language?.["Next"] ? language?.["Next"] : "Next"}
          </button>
        ) : (
          <button
            type="button"
            key="save"
            {...kb.primaryProps(handleSubmit)}
            style={{
              padding: "10px 20px",
              borderRadius: "30px",
              color: "#FFFFFF",
              fontSize: "14px",
              fontWeight: "500",
              backgroundColor: "#0F7679",
            }}
            className="font-inter cursor-pointer"
          >
            {language && language?.["Save"] ? language?.["Save"] : "Save"}
          </button>
        )}
      </div>
      {/* {tab === "profile" ?
                <>
                   
                    <PopupLocation show={showPopup} title={`${id === 'new' ? (language && language?.["Create Clients"]) ? language?.["Create Clients"] : "Create Clients" : language && language?.["Update Clients"] ? language?.["Update Clients"] : "Update Clients"}`} desc={`${id === 'new' ? (language && language?.["Create Clients Failed"]) ? language?.["Create Clients Failed"] : "Create Clients Failed" : language && language?.["Update Clients Failed"] ? language?.["Update Clients Failed"] : "Update Clients Failed"}`} onClose={handleClosePopup} onOpen={handleOpenPopup} />

                </>
                :
                <>
                    <TableReport PER_PAGE={filterActive.limit} pageClick={filterActive.page} languages={language} loading={loading} path="/sales/" data_table={invoicesActive.data} count={invoicesActive.count} handleSendPageNumber={handleReceivePageNumberActive} hiddenAction={true} noNagivateClick={{ check: true, name: language && language?.["Active Invoices"] ? language?.["Active Invoices"] : "Active Invoices" }} />
                    <div style={{ marginTop: "64px" }}>
                        <TableReport PER_PAGE={filterArchive.limit} pageClick={filterArchive.page} languages={language} loading={loading} path="/sales/" data_table={invoicesArchive.data} count={invoicesArchive.count} handleSendPageNumber={handleReceivePageNumberArchice} hiddenAction={true} noNagivateClick={{ check: true, name: language && language?.["Archive Invoices"] ? language?.["Archive Invoices"] : "Archive Invoices" }} />
                    </div>
                </>
            } */}
      </div>
      </div>
      {tab === "statement" && id !== "new" && (
        <div style={{ paddingBottom: "32px" }}>
          <ClientStatement
            clientId={id}
            companyId={companyId}
            language={language}
          />
        </div>
      )}
    </div>
  );
};
export default CreateClients;
